var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#A3C6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1512_30098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7232 31.793C43.3964 34.2853 42.3973 36.6415 40.8331 38.6091C39.2689 40.5767 37.1986 42.0813 34.8443 42.9617C32.4899 43.8421 29.9404 44.065 27.469 43.6065C24.9976 43.148 22.6976 42.0254 20.8157 40.3591C18.9338 38.6928 17.541 36.5457 16.7867 34.148C16.0323 31.7503 15.9449 29.1925 16.5338 26.7488C17.1226 24.3052 18.3656 22.068 20.1293 20.2771C21.893 18.4862 24.111 17.2092 26.5453 16.583C33.2936 14.8523 40.279 18.3259 42.8578 24.799",
    stroke: "#355BDF",
    strokeWidth: 4.61538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8413 16.1484V24.8023H35.1875",
    stroke: "#355BDF",
    strokeWidth: 4.61538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1512_30098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.5385,
    height: 41.5385,
    fill: "white",
    transform: "translate(9.22656 9.22656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon-reload.3eb456f0fdaaeeea2bae472a269f0aa1.svg";
export { ForwardRef as ReactComponent };